import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { interval, Subject } from 'rxjs';
import { ModalControlService } from 'src/app/services/modal-control.service';

@Component({
  selector: 'app-flight-inspection-style',
  templateUrl: './flight-inspection-style.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class FlightInspectionStyleComponent implements OnInit {
  @Input() title : string;
  @Input() colorIntervals :ColorInterval[] = [];
  @Input() validIntervals: boolean[] = [];
  selected: number;

  result: Subject<ColorInterval[]> = new Subject()
  constructor(public bsModalRef : BsModalRef,
    public modalService : ModalControlService
  ) { }

  ngOnInit(): void {
  }
  close(){
    this.bsModalRef.hide();
  }
  isIntervalCorrect(i:number){
    return this.colorIntervals[i].minValue != null && this.colorIntervals[i].maxValue != null && this.colorIntervals[i].minValue <= this.colorIntervals[i].maxValue;
  }
  checkIntersections(i:number){

    // check intersections
    this.validIntervals = new Array(this.colorIntervals.length).fill(true);
    for(let i = 0; i < this.colorIntervals.length-1; i++){
      if(!this.isIntervalCorrect(i)){
        this.validIntervals[i] = false;
        continue;
      }
      for(let j = i+1; j < this.colorIntervals.length; j++){
        if(!this.isIntervalCorrect(j)){
          this.validIntervals[j] = false;
          continue;
        }
        if(this.colorIntervals[i].maxValue > this.colorIntervals[j].minValue){
          this.validIntervals[i] = false;
          this.validIntervals[j] = false;
        }
      }
    }
  }
  changeValueToInfinite(intervalIndex:number, isValueInfinite:boolean, isMaxValue:boolean){
    let value: number;
    if (isValueInfinite) {
      value =  isMaxValue? Infinity: -Infinity;
    }
    else{
      value = null;
    }
    if(isMaxValue)
      this.colorIntervals[intervalIndex].maxValue = value
    else
      this.colorIntervals[intervalIndex].minValue = value
    this.checkIntersections(intervalIndex);
  }
  checkFormValidity(){
   return this.validIntervals.indexOf(false) == -1;
  }
  ok()  {
    this.result.next(this.colorIntervals);
    this.bsModalRef.hide();
  }
  remove(){
    if(this.selected == null){
      return;
    }
    this.colorIntervals.splice(this.selected,1);
    this.validIntervals.splice(this.selected,1);
    this.selected = null;
  }
  add(){
    this.colorIntervals.push(new ColorInterval(null,null,"#FFFFFF"));
    this.validIntervals.push(false);
  }

}

export class ColorInterval {
  constructor(
    public minValue: number,
    public maxValue: number,
    public color: string,
    public isMinValueInfinite: boolean = false,
    public isMaxValueInfinite: boolean = false,
  ) {
    if (this.isMaxValueInfinite) {
      this.maxValue = Infinity;
    } else {
      this.maxValue = Number(this.maxValue);
    }
  }

}
